import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Calendar from 'react-calendar';
import './PeriodPicker.css';
import { getRoundDate, addDay } from './DateFunctions';

export class PeriodPicker extends Component {
  displayName = PeriodPicker.name
  state = {
    focus: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    currentResource: undefined
  }
  
  componentDidUpdate() {
    const { period, resource } = this.props;
    const { currentResource } = this.state;

    if (!currentResource || resource.resource !== currentResource.resource || resource.resourceGroup !== currentResource.resourceGroup) {
      this.setState({ currentResource: resource });

      if (period && period.valid) {
        period.valid = this.verifyPeriod(period);

        if (this.props.onChange !== undefined) {
          this.props.onChange(period);
        }
      }
    }
  }

  onChange(date) {
    if (date !== undefined) {
      date = getRoundDate(date);

      const { period } = this.props;

      let newPeriod;

      if (period.valid || period.start === undefined || period.end === undefined) {
        let dayBeforeStart;
        let dayAfterEnd;

        if (period.start !== undefined && period.end !== undefined) {
          dayBeforeStart = addDay(period.start, -1);
          dayAfterEnd = addDay(period.end, 1);
        }

        let moreThan2Days = period.start !== undefined && period.end !== undefined && addDay(period.start, 1).getTime() < period.end.getTime();

        if (dayBeforeStart !== undefined && date.getTime() === dayBeforeStart.getTime()) {
          newPeriod = { start: dayBeforeStart, end: period.end };
        } else if (dayAfterEnd !== undefined && date.getTime() === dayAfterEnd.getTime()) {
          newPeriod = { start: period.start, end: dayAfterEnd };
        } else if (moreThan2Days && period.start !== undefined && period.end !== undefined && date.getTime() === period.start.getTime()) {
          newPeriod = { start: addDay(period.start, 1), end: period.end };
        } else if (moreThan2Days && period.start !== undefined && period.end !== undefined && date.getTime() === period.end.getTime()) {
          newPeriod = { start: period.start, end: addDay(period.end, -1) };
        } else if (period.start === undefined || (period.end !== undefined && period.end.getTime() !== date.getTime() && period.start.getTime() !== date.getTime())) {
          newPeriod = { start: date, end: undefined };
        }
        else {
          if (period.start > date) {
            newPeriod = { start: date, end: period.start };
          }
          else if (period.start.getTime() !== date.getTime()) {
            newPeriod = { start: period.start, end: date };
          }
        }
      }
      else {
        newPeriod = { start: date, end: undefined };
      }

      if (newPeriod !== undefined) {
        newPeriod.valid = this.verifyPeriod(newPeriod);

        if (this.props.onChange !== undefined) {
          this.props.onChange(newPeriod);
        }
      }
    }
  }

  verifyDate(date) {
    const { bookings } = this.props;
    const time = getRoundDate(date).getTime();

    let hasStart = false;
    let hasEnd = false;

    for (let i = 0; i < bookings.length; i++) {
      const startTime = getRoundDate(bookings[i].startDate).getTime();
      const endTime = getRoundDate(bookings[i].endDate).getTime();

      if (startTime < time && endTime > time) {
        return false;
      } else if (startTime === time) {
        hasStart = true;
      } else if (endTime === time) {
        hasEnd = true;
      }
    }

    return !(hasStart && hasEnd);
  }

  verifyPeriod(period) {
    const { bookings } = this.props;

    let date = new Date(period.start);
    while (date <= period.end) {
      for (let i = 0; i < bookings.length; i++) {
        if (getRoundDate(bookings[i].startDate).getTime() < date.getTime() && getRoundDate(bookings[i].endDate).getTime() > date.getTime()) {
          return false;
        }
      }
      date.setDate(date.getDate() + 1);
    }

    return true;
  }

  //getBookedClass(date) {
  getClass(date) {
    const { bookings, period } = this.props;
    const time = getRoundDate(date).getTime();

    let hasStart = false;
    let hasEnd = false;
    let hasBooking = false;

    for (let i = 0; i < bookings.length; i++) {
      const startTime = getRoundDate(bookings[i].startDate).getTime();
      const endTime = getRoundDate(bookings[i].endDate).getTime();

      if (startTime < time && endTime > time) {
        hasBooking = true;
      } else if (startTime === time) {
        hasStart = true;
      } else if (endTime === time) {
        hasEnd = true;
      }

      if (hasBooking || (hasStart && hasEnd)) return 'booked5';
    }

    let isSelected = false;
    let isSelectionStart = false;
    let isSelectionEnd = false;

    if (time >= getRoundDate(new Date()).getTime() && period !== undefined && period.valid) {
      isSelectionStart = period.start !== undefined && period.start.getTime() === time;
      isSelectionEnd = period.end !== undefined && period.end.getTime() === time;
      isSelected = period.start !== undefined && period.end !== undefined && period.start.getTime() < time && period.end.getTime() > time;
    }

    const bookedClass = hasStart ? 'booked5 booked-start' : (hasEnd ? 'booked5 booked-end' : '');
    const selectedClass = isSelected ? 'selected-period' : (isSelectionStart ? (hasStart ? 'selected-period period-end' : 'selected-period period-start') : (isSelectionEnd ? 'selected-period period-end' : ''));

    return `${bookedClass} ${selectedClass}`;
  }

  addMonth(date, interval) {
    let month = date.getMonth();
    let year = date.getFullYear();

    month += interval;
    if (month > 11) {
      month -= 12;
      year++;
    }
    else if (month < 0) {
      month += 12;
      year--;
    }

    return new Date(year, month, 1);
  }

  changeMonth(interval) {
    this.setState({ focus: this.addMonth(this.state.focus, interval) });
  }

  render() {
    let component = this;
    let months = [];
    let currentDate = new Date();
    let localizations = this.props.localizations;
    let numberOfCalendars = (this.props.numberOfCalendars !== undefined) ? this.props.numberOfCalendars : 3;

    for (let i = 0; i < numberOfCalendars; i++) {
      months.push(this.addMonth(this.state.focus, i));
    }

    let dateFormatter = new Intl.DateTimeFormat(localizations.Culture, {
      month: 'long',
      year: 'numeric'
    });

    return (
      <div className="periodpicker-container d-flex justify-content-sm justify-content-center-ys">
        {
          months.map(function (month, index) {
            let monthElement = <div className="month">{dateFormatter.format(month)}</div>;
            let prevButton = <Button bsStyle="primary" onClick={() => component.changeMonth(-1)}>&lt;</Button>;
            let nextButton = <Button bsStyle="primary" onClick={() => component.changeMonth(+ 1)}>&gt;</Button>;

            return (
              <div key={index} className={index === 0 ? "periodpicker d-flex flex-column" : "periodpicker d-flex flex-column hidden-ys"}>
                <div>
                  {index === 0 ?
                    <div>
                      <div className="d-flex justify-content-start hidden-ys">
                        {prevButton}
                        {monthElement}
                      </div>
                      <div className="visible-ys-block">
                        <div className="d-flex justify-content">
                          {prevButton}
                          {monthElement}
                          {nextButton}
                        </div>
                      </div>
                    </div>
                    : index < numberOfCalendars - 1 ?
                      <div className="d-flex justify-content-center">{monthElement}</div>
                      :
                      <div className="d-flex justify-content-end">
                        {monthElement}
                        {nextButton}
                      </div>
                  }
                </div>
                <div>
                  <Calendar
                    activeStartDate={month}
                    minDate={currentDate}
                    minDetail="year"
                    maxDetail="month"
                    showNeighboringMonth={false}
                    showNavigation={false}
                    onChange={(date) => component.onChange(date)}
                    showWeekNumbers
                    tileClassName={({ date, view }) => view === 'month' ? component.getClass(date) : null}
                    tileDisabled={({ date, view }) => view === 'month' ? !component.verifyDate(date) : false}
                    locale={localizations.Culture}
                  />
                </div>
              </div>
            );
          })
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/PeriodPicker.js